import { render, staticRenderFns } from "./SchemeTextList.vue?vue&type=template&id=180cb04b&scoped=true&"
import script from "./SchemeTextList.vue?vue&type=script&lang=js&"
export * from "./SchemeTextList.vue?vue&type=script&lang=js&"
import style0 from "./SchemeTextList.vue?vue&type=style&index=0&id=180cb04b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180cb04b",
  null
  
)

export default component.exports